import { environment } from 'src/environments/environment';

/**
 * 호스트 상품 편집 위저드(Next.js)로의 절대 URL.
 * 위저드 페이지가 host_product_wizard_enabled remote config로 게이트되어,
 * OFF 상태에서는 다시 host.nonunbub.com Angular legacy로 redirect한다.
 *
 * meeting-add 후속 이동, hosted-meetings 편집 진입 등 여러 곳에서 같은 URL을
 * 만들기 때문에 헬퍼로 모아 환경/경로 변경 시 한 곳만 수정.
 *
 * `step`을 주면 그 하위 단계로 바로 이동하는 URL을 돌려준다(NNB-1101) — 지금은 `review` 하나뿐이라
 * union으로 좁혀 오타가 컴파일 타임에 걸리게 한다.
 */
export function getHostProductEditUrl(productId: number | string, step?: 'review'): string {
  const base = `${environment.webDomain}/host/products/${encodeURIComponent(String(productId))}/edit`;
  return step ? `${base}/${encodeURIComponent(step)}` : base;
}
